import React from 'react';
const ReadingList = () => <h3>ReadingList</h3>;

export default ReadingList;



// WEBPACK FOOTER //
// ./src/components/ReadingList/ReadingList.js